/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from 'ng2-translate/src/translate.pipe';
import * as i2 from 'ng2-translate/src/translate.service';
import * as i3 from '../../../../../app/components/widgets/form-page-button-block/form-page-button-block.component';
import * as i4 from '@angular/common';
import * as i5 from '@angular/router';
const styles_FormPageButtonBlockWidget:any[] = ([] as any[]);
export const RenderType_FormPageButtonBlockWidget:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_FormPageButtonBlockWidget,data:{}});
function View_FormPageButtonBlockWidget_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),6,'div',[['class',
      'pull-right']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted(-1,(null as any),['\n  '])),(_l()(),i0.ɵeld(2,0,(null as any),
          (null as any),3,'button',[['class','btn btn-w-md btn-line-success'],['type',
              'submit']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(3,0,(null as any),(null as any),0,'i',[['class','fa fa-check']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted(4,(null as any),[' ',''])),i0.ɵpid(131072,i1.TranslatePipe,[i2.TranslateService,
          i0.ChangeDetectorRef]),(_l()(),i0.ɵted(-1,(null as any),['\n']))],(null as any),
      (_ck,_v) => {
        const currVal_0:any = i0.ɵunv(_v,4,0,i0.ɵnov(_v,5).transform('general.save'));
        _ck(_v,4,0,currVal_0);
      });
}
export function View_FormPageButtonBlockWidget_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),6,'div',[['class',
      'pull-left']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted(-1,(null as any),['\n  '])),(_l()(),i0.ɵeld(2,0,(null as any),
          (null as any),3,'a',[['class','btn btn-w-md btn-line-info']],(null as any),
          [[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i3.FormPageButtonBlockWidget = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.back()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i0.ɵeld(3,0,(null as any),(null as any),
          0,'i',[['class','fa fa-undo']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i0.ɵted(4,(null as any),[' ',''])),
      i0.ɵpid(131072,i1.TranslatePipe,[i2.TranslateService,i0.ChangeDetectorRef]),
      (_l()(),i0.ɵted(-1,(null as any),['\n'])),(_l()(),i0.ɵted(-1,(null as any),['\n'])),
      (_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_FormPageButtonBlockWidget_1)),
      i0.ɵdid(9,16384,(null as any),0,i4.NgIf,[i0.ViewContainerRef,i0.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵted(-1,(null as any),['\n']))],
      (_ck,_v) => {
        var _co:i3.FormPageButtonBlockWidget = _v.component;
        const currVal_1:any = _co.showSave;
        _ck(_v,9,0,currVal_1);
      },(_ck,_v) => {
        var _co:i3.FormPageButtonBlockWidget = _v.component;
        const currVal_0:any = i0.ɵunv(_v,4,0,i0.ɵnov(_v,5).transform(_co.cancelText));
        _ck(_v,4,0,currVal_0);
      });
}
export function View_FormPageButtonBlockWidget_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'form-page-button-block',
      ([] as any[]),(null as any),(null as any),(null as any),View_FormPageButtonBlockWidget_0,
      RenderType_FormPageButtonBlockWidget)),i0.ɵdid(1,49152,(null as any),0,i3.FormPageButtonBlockWidget,
      [i4.Location,i5.Router],(null as any),(null as any))],(null as any),(null as any));
}
export const FormPageButtonBlockWidgetNgFactory:i0.ComponentFactory<i3.FormPageButtonBlockWidget> = i0.ɵccf('form-page-button-block',
    i3.FormPageButtonBlockWidget,View_FormPageButtonBlockWidget_Host_0,{showSave:'showSave',
        cancelText:'cancelText',goBackLink:'goBackLink'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Vzci9zcmMvYXBwL3NyYy9hcHAvY29tcG9uZW50cy93aWRnZXRzL2Zvcm0tcGFnZS1idXR0b24tYmxvY2svZm9ybS1wYWdlLWJ1dHRvbi1ibG9jay5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vdXNyL3NyYy9hcHAvc3JjL2FwcC9jb21wb25lbnRzL3dpZGdldHMvZm9ybS1wYWdlLWJ1dHRvbi1ibG9jay9mb3JtLXBhZ2UtYnV0dG9uLWJsb2NrLmNvbXBvbmVudC50cyIsIm5nOi8vL3Vzci9zcmMvYXBwL3NyYy9hcHAvY29tcG9uZW50cy93aWRnZXRzL2Zvcm0tcGFnZS1idXR0b24tYmxvY2svZm9ybS1wYWdlLWJ1dHRvbi1ibG9jay5odG1sIiwibmc6Ly8vdXNyL3NyYy9hcHAvc3JjL2FwcC9jb21wb25lbnRzL3dpZGdldHMvZm9ybS1wYWdlLWJ1dHRvbi1ibG9jay9mb3JtLXBhZ2UtYnV0dG9uLWJsb2NrLmNvbXBvbmVudC50cy5Gb3JtUGFnZUJ1dHRvbkJsb2NrV2lkZ2V0X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiBjbGFzcz1cInB1bGwtbGVmdFwiPlxuICA8YSAoY2xpY2spPVwiYmFjaygpXCIgIGNsYXNzPVwiYnRuIGJ0bi13LW1kIGJ0bi1saW5lLWluZm9cIj48aSBjbGFzcz1cImZhIGZhLXVuZG9cIj48L2k+IHt7Y2FuY2VsVGV4dCB8IHRyYW5zbGF0ZX19PC9hPlxuPC9kaXY+XG48ZGl2ICpuZ0lmPVwic2hvd1NhdmVcIiBjbGFzcz1cInB1bGwtcmlnaHRcIj5cbiAgPGJ1dHRvbiB0eXBlPVwic3VibWl0XCIgY2xhc3M9XCJidG4gYnRuLXctbWQgYnRuLWxpbmUtc3VjY2Vzc1wiPjxpIGNsYXNzPVwiZmEgZmEtY2hlY2tcIj48L2k+IHt7J2dlbmVyYWwuc2F2ZScgfCB0cmFuc2xhdGV9fTwvYnV0dG9uPlxuPC9kaXY+XG4iLCI8Zm9ybS1wYWdlLWJ1dHRvbi1ibG9jaz48L2Zvcm0tcGFnZS1idXR0b24tYmxvY2s+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0dBO01BQUE7TUFBeUMsNENBQ3ZDO1VBQUE7Y0FBQTtNQUE0RDtVQUFBO01BQTJCOzhCQUFBLEdBQXdDOztRQUF4QztRQUFBOzs7O29CQUp6RjtNQUFBO01BQXVCLDRDQUNyQjtVQUFBO1VBQUE7WUFBQTtZQUFBO1lBQUc7Y0FBQTtjQUFBO1lBQUE7WUFBSDtVQUFBLGdDQUF3RDtVQUFBO1VBQUEsOEJBQTBCO2FBQUE7TUFBK0IsMENBQzdHO01BQ047YUFBQTtVQUFBLGlDQUVNOzs7UUFGRDtRQUFMLFdBQUssU0FBTDs7O1FBRm9GO1FBQUE7Ozs7b0JDRHBGO01BQUE7MENBQUEsVUFBQTtNQUFBOzs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/components/widgets/form-page-button-block/form-page-button-block.component.ngfactory.ts